// 希伯来语
const he = {
    // 首页-激活说明
    activateExplain: {
        title: 'הפעל את האחריות המורחבת שלך וקבל את המתנה המיוחדת עבורך',
        desp: 'תנאי שימוש: כדי להעפיל, הלקוחות מסכימים לשתף את חווית הקנייה שלהם עם המוצרים שנרכשו והמשתמשים בהם פעיל לפחות שבוע.',
        conditions: [
            'רק ללקוחות שקנו את המוצרים ב- Amazon',
            'כל לקוח יכול לתבוע מתנה אחת בחינם עבור מוצר אחד בלבד. (מה שאומר שלא משנה כמה פעמים אתם רוכשים את אותו המוצר, תוכלו לקבל מתנה אחת בחינם).',
        ]
    },
    // 首页-激活表单
    activateForm: {
        title: 'הפעל את האחריות המורחבת שלך וקבל את המתנה בחינם עכשיו!',
        desp: 'זמין רק ללקוחות קיימים',
        name: 'שם',
        namePlaceholder: `הזן את שם הנמען`,
        nameErrMsg: `השם אינו נכון.`,
        email: 'שלח',
        emailPlaceholder: `שלח את הדוא"ל שלך`,
        emailErrMsg: `הדוא"ל שגוי.`,
        verifCode: 'קוד אימות',
        verifCodePlaceholder: `הזן את קוד האימות שלך`,
        verifCodeErrMsg: `קוד אימות שגוי.`,
        btnSendCode: `שלח את קוד האימות`,
        countdownMsg: `שלח שוב תוך {countdown} שניות`,
        orderId: 'מזהה הזמנה',
        orderIdPlaceholder: `הזן את מזהה ההזמנה שלך`,
        orderIdErrMsg: `זיהוי ההזמנה אינו נכון.`,
        orderAppliedError: `הזמנה זו כבר הגישה בקשה למתנה.`,
        skuAppliedError: `המתנה להזמנה זו נאספה.`,
        orderIdHelp: 'כיצד למצוא את מזהה ההזמנה שלך?',
        btnAactivate: 'הפעל עכשיו',
        statement: 'אנו בוודאי לא נשתף את המידע האישי שלך לאחרים.',
        orderIdErrPopoverMsg: 'אם מזהה ההזמנה שלך נכון בוודאות, אנא צור קשר עם שירות הלקוחות שלנו באמצעות הדוא"ל. אנו נעזור לך להפעיל את האחריות המורחבת ולאשר אם האירוע מכסה את שוקך.',
        priceErrPopoverMsg: 'אנו כל כך מצטערים לומר לך שההזמנה הזו השתמשה בהנחה הנמוכה ביותר שלנו, אם יש בעיות, ברוך הבא לשלוח לנו דוא"ל.'
    },
    // 通用弹框
    commonModal: {
        msg: `{msg}`,
        msgContents: [
            `שם הנמען לא יכול להתאים להזמנה`,
            `האם הביקורת של אמזון הושלמה?`,
            `האם תרצה להמשיך לאמזון לסקור?`
        ],
        btnRewrite: 'לשכתב',
        btnNo: 'לא',
        btnYes: 'כן'
    },
    // 选择礼物
    chooseGift: {
        title: 'כעת בחרו את המתנה הרצויה לכם.',
        modalTitle: 'מצטערים, המתנה שבחרת כבר לא זמינה, אנא בחר שוב',
        btnWant: 'אני רוצה את זה',
        btnStockout: 'נגמר המלאי'
    },
    // 订单信息
    orderInfo: {
        title: 'מזל טוב! האחריות המורחבת שלך מופעלת!',
        desp: 'מה תקבלו',
        orderTitle: 'פרטי ההזמנה שלך',
        orderId: 'מספר הזמנה',
        productASIN: 'מוצר ASIN',
        productName: 'כותרת מוצר',
        address: 'כתובת',
        aboutGift: [
            'על המתנה',
            'אין דמי משלוח, אין עמלות נסתרות, אין צורך בכרטיס אשראי.',
            'צעדים פשוטים להשגתו (פחות מחמש דקות).',
            'המתנה תישלח אליכם תוך 2-5 ימי עבודה לאחר שתביע אותה.'
        ],
        btnWant: 'אני רוצה את זה'
    },
    // 步骤1
    stepOne: {
        title: 'שלב 1 מתוך 4: סקר קצר אודות הרכישה שלך.',
        questionList: [{
                id: 1,
                select_type: 'radio',
                name: 'sex',
                title: '1. אני ...?',
                option: [{
                        txt: 'נקבה',
                        value: 0
                    },
                    {
                        txt: 'זכר',
                        value: 1
                    },
                    {
                        txt: 'לא בטוח',
                        value: 2
                    }
                ]
            },
            {
                id: 2,
                select_type: 'radio',
                name: 'age',
                title: `2. מה טווח הגילאים שלך?`,
                option: [{
                        txt: 'פחות מ 20',
                        value: 0
                    },
                    {
                        txt: '20-30',
                        value: 1
                    },
                    {
                        txt: '30-40',
                        value: 2
                    },
                    {
                        txt: '40-50',
                        value: 3
                    },
                    {
                        txt: '50-60',
                        value: 4
                    },
                    {
                        txt: 'יותר מ 60',
                        value: 5
                    }
                ]
            },
            {
                id: 3,
                select_type: 'radio',
                name: 'reason',
                title: '3. מדוע בחרת בנו?',
                option: [{
                        txt: 'מותג',
                        value: 0
                    },
                    {
                        txt: 'עיצוב',
                        value: 1
                    },
                    {
                        txt: 'מחיר',
                        value: 2
                    },
                    {
                        txt: 'מאפיינים',
                        value: 3
                    },
                    {
                        txt: 'ביקורות',
                        value: 4
                    },
                    {
                        txt: 'סיבות אחרות',
                        value: 5,
                        placeholder: 'אנא הזן סיבה'
                    }
                ]
            },
        ],
        btnNext: 'השלב הבא'
    },
    // 步骤2
    stepTwo: {
        title: 'שלב 2 מתוך 4: ספר לארה"ב על החוויה שלך לגבי המוצר.',
        despOne: `דירוג כללי?`,
        despTwo: `תן לנו לדעת כיצד המוצרים שלנו עובדים בשבילך.`,
        notice: `(הזן לפחות 10 תווים)`,
        commentPlaceholder: 'הזן את התגובה שלך',
        commentErrMsg: `מילות תגובה לא יכולות לעלות על 20,000`,
        btnNext: 'השלב הבא',
        btnPrev: 'צעד קודם'
    },
    // 步骤3
    stepThree: {
        title: 'שלבים 3 מתוך 4: שתפו את חווית הקנייה שלכם עם אחרים.',
        desp: 'פשוט לוקח לך כמה שניות. התגובות שלך יעזרו ללקוחות אחרים לקבל החלטת קנייה טובה יותר. תודה על ההבנה והתמיכה שלך.',
        commentTitle: 'התגובות שלך',
        defaultComment: 'אני אוהב מאוד את המוצר שלך!',
        btnCopyPost: 'לחץ כאן כדי להעתיק ולפרסם את סקירת Amazon שלך'
    },
    // 步骤4
    stepFour: {
        title: 'שלב 4 מתוך 4: אשר את הכתובת שלך.',
        desp: 'מה תקבלו',
        fullName: 'שם מלא',
        fullNamePlaceholder: `הזן את שמך המלא`,
        fullNameErrMsg: `השם המלא שגוי`,
        phone: 'טלפון',
        phonePlaceholder: `הזן את הטלפון שלך`,
        phoneErrMsg: `הטלפון שגוי`,
        email: 'שלח',
        emailPlaceholder: `שלח את הדוא"ל שלך`,
        emailErrMsg: `הדוא"ל שגוי`,
        address: 'כתובת',
        addressPlaceholder: `הזן את הכתובת שלך`,
        addressErrMsg: `הכתובת שגויה`,
        streetPlaceholder:`כתובת רחוב`,
        apartmentPlaceholder:`דירה / יחידה`,
        cityPlaceholder:`עִיר`,
        regionPlaceholder: `בחר מחוז`,
        countryPlaceholder: `בחר ארץ`,
        postcode: 'מיקוד',
        postcodePlaceholder: `הזן את המיקוד שלך`,
        postcodeErrMsg: `המיקוד שגוי`,
        btnComfirm: 'אשר'
    },
    // 完成礼物申请
    completeApplication: {
        title: `סיימת את אפליקציית המתנה בחינם`,
        msgs: [
            'המתנה בחינם תישלח תוך 2-5 ימי עבודה.',
            'המתנה בחינם תישלח למייל שלך ',
            ' תוך 2-5 ימי עבודה. תודה רבה לך על רכישת המוצרים שלנו, ואז יהיה איש קשר ייעודי לאחר המכירה.',
            'כל בעיה נוספת שתקבל, אנא צור קשר עם שירות הלקוחות שלנו באמצעות הדוא"ל או בקר באתר הרשמי שלנו.',
            'מכיוון שאתה לא מרוצה במאה אחוז מהמוצרים שלנו, אתה יכול ליצור קשר עם שירות הלקוחות שלנו באמצעות דואר אלקטרוני או לבקר באתר הרשמי שלנו, יהיו אנשי מקצוע שישרתו אותך. שביעות רצון לקוחות 100% היא הערובה שלנו!'
        ],
        btnComfirm: 'אשר'
    },
    // 获取订单号指导
    guide: {
        title: 'כיצד למצוא את מזהה ההזמנה שלך?',
        desps: [
            `שלב 1: התחבר לחשבון אמזון שלך ולחץ על "ההזמנה שלך" בדף חשבון ורשימות`,
            `שלב 2: לחץ על "פרטי הזמנה" בסדר הנכון`,
            `שלב 3: תראה את מזהה ההזמנה שלך`
        ],
        btnOK: 'בסדר'
    }
}

export default he